<template>
  <Layout>
    <FeatureFieldAlert required-field="gender" />
    <hotels></hotels>
    <rooms></rooms>
    <allocation></allocation>
    <div class="row">
    </div>
  </Layout>
</template>
<script>
import Layout from '@/components/layout/vertical'
import Hotels from './hotel/Hotels'
import Rooms from './hotel/Rooms'
import Allocation from './hotel/HotelAllocation'
import FeatureFieldAlert from '@/components/FeatureFieldAlert'
import appConfig from '@/app.config'

export default {
  components: {
    Layout,
    Hotels,
    Rooms,
    Allocation,
    FeatureFieldAlert
  },
  name: 'roomlist',
  page: {
    title: 'Gestão de Hospedagem',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      title: 'Gestão de Hospedagem'
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.inativado { background: #f7ebeb }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: auto !important}
.float-sm-end { float: right }
</style>
